const avatarPalette = (tokens) => {
    return {
        font: {
            family: tokens.avatarFontFamily,
            weight: tokens.avatarFontWeight,
            fontWeight: tokens.avatarFontWeight,
            letterSpacing: tokens.avatarLetterSpacing,
            textTransform: tokens.avatarTextCase
        },
        border: {
            width: tokens.avatarBorderWidthDefault,
            radius: tokens.avatarRadiusRound
        },
        size: {
            small: {
                width: tokens.avatarSizeS,
                height: tokens.avatarSizeS,
                font: {
                    size: tokens.avatarFontSizeS,
                    lineHeight: tokens.avatarLineHeightS
                }
            },
            medium: {
                width: tokens.avatarSizeM,
                height: tokens.avatarSizeM,
                font: {
                    size: tokens.avatarFontSizeM,
                    lineHeight: tokens.avatarLineHeightM
                }
            },
            large: {
                width: tokens.avatarSizeL,
                height: tokens.avatarSizeL,
                font: {
                    size: tokens.avatarFontSizeL,
                    lineHeight: tokens.avatarLineHeightL
                }
            },
            xlarge: {
                width: tokens.avatarSizeXl,
                height: tokens.avatarSizeXl,
                font: {
                    size: tokens.avatarFontSizeXl,
                    lineHeight: tokens.avatarLineHeightXl
                }
            },
            xxlarge: {
                width: tokens.avatarSizeXxl,
                height: tokens.avatarSizeXxl,
                font: {
                    size: tokens.avatarFontSizeXxl,
                    lineHeight: tokens.avatarLineHeightXxl
                }
            }
        },
        static: {
            neutral: {
                background: tokens.avatarColorBgStaticNeutral,
                border: tokens.avatarColorBorderStaticNeutral,
                text: tokens.avatarColorTextStaticNeutral
            },
            emphasis: {
                background: tokens.avatarColorBgStaticEmphasis,
                border: tokens.avatarColorBorderStaticEmphasis,
                text: tokens.avatarColorTextStaticEmphasis
            },
            subtle: {
                background: tokens.avatarColorBgStaticSubtle,
                border: tokens.avatarColorBorderStaticSubtle,
                text: tokens.avatarColorTextStaticSubtle
            }
        },
        interactive: {
            emphasis: {
                background: {
                    default: tokens.avatarColorBgInteractiveEmphasisDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveEmphasisFocus,
                    hover: tokens.avatarColorBgInteractiveEmphasisHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveEmphasisDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveEmphasisFocus,
                    hover: tokens.avatarColorBorderInteractiveEmphasisHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveEmphasisSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveEmphasis,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            neutral: {
                background: {
                    default: tokens.avatarColorBgInteractiveNeutralDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveNeutralFocus,
                    hover: tokens.avatarColorBgInteractiveNeutralHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveNeutralDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveNeutralFocus,
                    hover: tokens.avatarColorBorderInteractiveNeutralHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveNeutralSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveNeutral,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            subtle: {
                background: {
                    default: tokens.avatarColorBgInteractiveSubtleDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveSubtleFocus,
                    hover: tokens.avatarColorBgInteractiveSubtleHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveSubtleDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveSubtleFocus,
                    hover: tokens.avatarColorBorderInteractiveSubtleHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveSubtleSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveSubtle,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            disabled: {
                background: tokens.avatarColorBgInteractiveDisabled,
                border: tokens.avatarColorBorderInteractiveDisabled,
                text: tokens.avatarColorTextInteractiveDisabled
            }
        }
    };
};
export default avatarPalette;
//# sourceMappingURL=avatar.js.map